import { IntlShape } from 'react-intl';

export const getLocaleCurrency = (
  intl: IntlShape,
  CurrencyCode: string
): string => {
  const parts = intl.formatNumberToParts(0, {
    style: 'currency',
    currency: CurrencyCode,
    currencyDisplay: 'narrowSymbol',
  });
  return parts.find((part) => part.type === 'currency')?.value ?? '';
};

export function formatCurrencyAmount(
  intl: IntlShape,
  currencyCode: string,
  minAmount: number,
  maxAmount: number
) {
  const currencySymbol = getLocaleCurrency(intl, currencyCode);
  const minAmountDisplay = intl.formatNumber(minAmount, {
    notation: 'compact',
  });
  const maxAmountDisplay = intl.formatNumber(maxAmount, {
    notation: 'compact',
  });

  return `${currencySymbol} ${minAmountDisplay} - ${maxAmountDisplay}`;
}

/**
 * Convert salary amount to label
 * @param salaryAmount - Salary amount
 * @param currencyCode - Currency code
 * @param intl - IntlShape
 * @param salaryType - 'min' | 'max'
 * @returns Salary amount label
 */
export function convertSalaryAmountToLabel(
  salaryAmount: number,
  currencyCode: string,
  intl: IntlShape,
  salaryType: 'min' | 'max'
) {
  const initialAmount =
    salaryType === 'min'
      ? intl.formatMessage({
          id: 'text-no-minimum',
          defaultMessage: 'No Min.',
        })
      : '';

  return salaryAmount > 0
    ? intl.formatNumber(salaryAmount, {
        notation: 'compact',
        currency: currencyCode,
      })
    : initialAmount;
}
